import { httpRequest } from "../../http";
import { CatalogVertical } from "@models/catalog.model";

export class CommandListVerticals {
  async run(): Promise<CatalogVertical[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/catalog/verticals/`;
    return httpRequest<CatalogVertical[]>(url, { method: "GET" });
  }
}
